import {memo} from 'react';

import {useSelector} from 'react-redux';

import Input, {InputProps} from '~/shared/components/Input';
import {selectA11yContrast} from '~/shared/store/selectors';

const CommonInput = (props: Omit<InputProps, 'isContrastActive'>) => {
  const isContrastActive = useSelector(selectA11yContrast);

  return <Input {...props} isContrastActive={isContrastActive}/>;
};

export default memo(CommonInput);
